/** Thin client for ttp.worker.ts, matching the runWorker() pattern used elsewhere in this app. */
import { runWorker, ab } from "./worker-client";
import type { Dims3, Dims4 } from "./ttp-math";

import { appPath } from "./assets";
export interface TtpInput {
  pwi: Float32Array; // F-order [x,y,z,t]
  dims: Dims4;
  pixdim: Dims4; // [dx,dy,dz,TR]
  mask: Uint8Array; // F-order [x,y,z], required — see ttp.worker.ts header
  sliceTiming?: number[];
  echoTime?: number;
}

export interface TtpResult {
  ttp: Float32Array;
  dims: Dims3;
  baselineVolumes: number;
  skipVolumesForPeaks: number;
  timeRefSeconds: number[];
  totalMs: number;
}

export function runTtp(input: TtpInput, onProgress?: (stage: string) => void): Promise<TtpResult> {
  const worker = new Worker(appPath("workers/ttp.worker.js"), { type: "module" });
  const payload = {
    pwi: ab(input.pwi),
    dims: input.dims,
    pixdim: input.pixdim,
    mask: ab(input.mask),
    sliceTiming: input.sliceTiming,
    echoTime: input.echoTime,
  };
  return runWorker<typeof payload, { ttp: ArrayBuffer } & Omit<TtpResult, "ttp">>(
    worker,
    payload,
    onProgress
  ).then((d) => ({ ...d, ttp: new Float32Array(d.ttp as unknown as ArrayBuffer) })).finally(() => worker.terminate());
}
